import { FC } from 'react';
import { Box } from '@mui/material';
import { AdminRegisterForm } from '@/components/Auth';

export const AdminRegisterUserPage: FC = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <AdminRegisterForm />
    </Box>
  );
};

export default AdminRegisterUserPage;
